<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="60%"
    top="60px"
    :fullscreen="dialogFull"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleClose"
    append-to-body
    :modal-append-to-body="false"
  >
    <template slot="title">
      <div class="avue-crud__dialog__header">
        <span class="el-dialog__title"> 编辑开票信息 </span>
        <i
          class="el-icon-full-screen"
          style="margin-right: 20px; position: relative; top: -1px"
          @click="dialogFull = !dialogFull"
        ></i>
      </div>
    </template>
    <avue-form ref="form" v-model="form" :option="option" @submit="submit"></avue-form>
    <template slot="footer">
      <el-button @click="formSubmit1" size="small" type="primary"
        ><span class="el-icon-check"></span> 保存</el-button
      >
      <el-button @click="handleClose" size="small" style="margin-right: 15px"
        ><span class="el-icon-close"></span> 取消</el-button
      >
    </template>
  </el-dialog>
</template>
<script>
import { invoiceDescription } from '@/api/v4ward/carv2/carmonthchargerule';
export default {
  data() {
    return {
      dialogVisible: false,
      dialogFull: false,
      form: {},
      option: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '车场名称',
            prop: '$spaceId',
            disabled: true,
            span: 8,
          },
          {
            label: '车牌号',
            prop: 'carNo',
            disabled: true,
            span: 8,
          },
          {
            label: '收费金额',
            prop: 'payMoney',
            disabled: true,
            span: 8,
          },
          {
            label: '开始日期',
            prop: 'buyEndTime',
            type: 'date',
            disabled: true,
            span: 8,
          },
          {
            label: '结束日期',
            prop: 'buyStartTime',
            type: 'date',
            disabled: true,
            span: 8,
          },
          {
            label: '支付时间',
            prop: 'payTime',
            disabled: true,
            span: 8,
          },
          {
            label: '开票信息',
            type: 'textarea',
            maxlength: 500,
            showWordLimit: true,
            prop: 'invoiceDescription',
            span: 24,
          },
        ],
      },
    };
  },
  methods: {
    openDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    submit(form, loading) {
      let params = {
        id: form.id,
        invoiceDescription: form.invoiceDescription,
      };
      invoiceDescription(params)
        .then((res) => {
          if (res.msg == '操作成功') {
            this.$message({
              message: res.msg,
              type: 'success',
            });
            this.$emit('onLoad');
            this.dialogVisible = false;
            this.dialogShow = false;
          } else {
            this.$message.error(res.msg);
          }
          loading();
        })
        .catch((err) => {
          loading();
        });
    },
    formSubmit1() {
      this.$refs.form.submit();
    },
    // 弹窗关闭前
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.dialogVisible = false;
        })
        .catch(() => {});
    },
  },
};
</script>
